import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { LanguageService } from '../../../../core/services/language.service';
import { CoreControlDirective } from '../../../utils/core-control.directive';
import { InputNumberVariant } from './contract/input-number-variant.contract';

@Component({
  selector: 'osp-input-number',
  templateUrl: './input-number.component.html',
  styleUrl: './input-number.component.scss',
  standalone: true,
  imports: [ReactiveFormsModule, InputNumberModule],
  providers: CoreControlDirective.coreControlProvider(InputNumberComponent),
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputNumberComponent extends CoreControlDirective {
  @HostBinding('class.osp-input-number') protected hostCssClassEnabled = true;

  currentLocale = inject(LanguageService).getCurrentLocale();

  @Input() variant: InputNumberVariant = 'outlined';
  @Input() showButtons = false;
  @Input() format = true;
  @Input() buttonLayout: 'stacked' | 'vertical' = 'stacked';
  @Input() inputId?: string;
  @Input() size?: number;
  @Input() maxLength: string | number | null = null;
  @Input() tabindex?: number;
  @Input() title?: string;
  @Input() name?: string;
  @Input() autocomplete?: string;
  @Input() min?: number;
  @Input() max?: number;
  @Input() incrementButtonClass?: string;
  @Input() decrementButtonClass?: string;
  @Input() incrementButtonIcon?: string;
  @Input() decrementButtonIcon?: string;
  @Input() readonly = false;
  @Input() step = 1;
  @Input() allowEmpty = true;
  @Input() localeMatcher?: string;
  @Input() mode: string = 'decimal';
  @Input() currency?: string;
  @Input() currencyDisplay?: string;
  @Input() useGrouping = true;
  @Input() minFractionDigits: number | null = null;
  @Input() maxFractionDigits: number | null = null;
  @Input() prefix?: string;
  @Input() suffix?: string;
  @Input() inputStyleClass?: string;
  @Input() showClear = false;
  @Input() autofocus = false;
  @Input() placeholder = '';
  @Input() cssClass = '';
  @Input() helpText: string = '';
  @Input() readOnly = false;

  @Output() onFocus = new EventEmitter<FocusEvent>();
  @Output() onBlur = new EventEmitter<FocusEvent>();
  @Output() onInput = new EventEmitter<string>();

  handleFocus(event: FocusEvent) {
    this.onFocus.emit(event);
  }

  handleBlur(event: FocusEvent) {
    this.onBlur.emit(event);
  }

  handleInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.onInput.emit(inputElement.value);
  }
}
